<template>
  <div>
    <div style="margin-top: 80px;">
      <div style="width: 100%; max-width: 1920px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
          <div style="display: flex; flex-direction: column; align-items: center;">
              <span :style="'font-size: '+$store.getters.getFontSizes.f28+'; font-weight: 500;'">
                Upgrade the way you run your tailoring
              </span>
              <span :style="'font-size: '+$store.getters.getFontSizes.f28+'; font-weight: 500;'">
                business with our cloud-based application
              </span>
          </div>
          <div :style="'margin-top: 100px; width: 100%; display: flex; flex-direction: '+($store.getters.getScreenWidth<1024 ? 'column' : 'row')+'; justify-content: space-between; align-items: '+($store.getters.getScreenWidth<1024 ? 'center' : 'space-between')+';'">
            <img src="https://etacdn.b-cdn.net/new-website/laptop.png" style="width: 48%;" alt="easytailorapp">
            <div :style="'text-align: left; width: '+($store.getters.getScreenWidth<1024 ? '90%' : '50%')+'; margin-top: '+($store.getters.getScreenWidth<1024 ? '100px;' : '')+'; margin-left: '+($store.getters.getScreenWidth<1024 ? '' : '2%')+'; display: flex; flex-direction: column; justify-content: center; align-items: flex-start;'">
                <span style="font-size: 24px; font-weight: 500;">
                    Controlled Workflow
                </span>
                <span style="margin-bottom: 50px; color: #7b7b7b; margin-top: 16px; font-size: 18px; font-weight: 500;">
                    Leave less room for human error with these amazing feature list of<br>Easy Tailor App.
                </span>
                <div
                    v-for="(data, index) in getFeatureList"
                    :key="index" 
                    style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                    <span v-html="data" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                        
                    </span>
                </div>                
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        getFeatureList() {
            return [
                'Handle multiple stores centrally.', 
                'Integrated e-payment &amp; e-commerce.',
                'Unlimited users, pay for the software not the users.',
                'Manage every aspect of your business centrally.'
            ]
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Row2.vue